import { spaceTypes } from '../spaceTypes';
import countries from 'constants/countries';
import { getSize, getAssignedseatsBasedQuantities, getFixedQuantities } from './utils';

export const workstation = [
  {
    id: 4,
    name: 'spaceTypes.workstation.bench',
    displayOrder: 1,
    spaceTypeId: spaceTypes.workstation.id,
    size: {
      [countries.US]: getSize(5.0, 5.0),
      [countries.UK]: getSize(5.0, 5.0),
      [countries.FR]: getSize(2.7, 1.3),
      [countries.EU]: getSize(2.0, 3.5),
      [countries.DE]: getSize(2.0, 3.5),
    },
    quantity: {
      [countries.US]: getAssignedseatsBasedQuantities(0, 0, 1),
      [countries.UK]: getAssignedseatsBasedQuantities(0, 0, 1),
      [countries.FR]: getAssignedseatsBasedQuantities(0, 0, 0.8),
      [countries.EU]: getAssignedseatsBasedQuantities(1, 0, 0),
      [countries.DE]: getAssignedseatsBasedQuantities(1, 0, 0),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499747/insite/qa/spaces/x4qwutwknpryiwstw3nr.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499747/insite/qa/spaces/x4qwutwknpryiwstw3nr.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499747/insite/qa/spaces/x4qwutwknpryiwstw3nr.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499747/insite/qa/spaces/x4qwutwknpryiwstw3nr.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499747/insite/qa/spaces/x4qwutwknpryiwstw3nr.jpg',
    },
    countries: [countries.US, countries.FR, countries.EU, countries.DE],
  },
  {
    id: 5,
    name: 'spaceTypes.workstation.small',
    displayOrder: 2,
    spaceTypeId: spaceTypes.workstation.id,
    size: {
      [countries.US]: getSize(6.0, 6.0),
      [countries.UK]: getSize(5.0, 5.0),
      [countries.FR]: getSize(2.02, 1.74),
      [countries.EU]: getSize(2.0, 2.0),
      [countries.DE]: getSize(2.0, 2.0),
    },
    quantity: {
      [countries.US]: getFixedQuantities(0),
      [countries.UK]: getAssignedseatsBasedQuantities(0, 0, 1),
      [countries.FR]: getFixedQuantities(0),
      [countries.EU]: getFixedQuantities(0),
      [countries.DE]: getFixedQuantities(0),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818104/insite/qa/spaces/s0pgad8yducasgyxosvr.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818104/insite/qa/spaces/s0pgad8yducasgyxosvr.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499747/insite/qa/spaces/x4qwutwknpryiwstw3nr.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818104/insite/qa/spaces/s0pgad8yducasgyxosvr.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818104/insite/qa/spaces/s0pgad8yducasgyxosvr.jpg',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
  {
    id: 6,
    name: 'spaceTypes.workstation.medium',
    displayOrder: 3,
    spaceTypeId: spaceTypes.workstation.id,
    size: {
      [countries.US]: getSize(8.0, 6.0),
      [countries.UK]: getSize(6.0, 6.0),
      [countries.FR]: getSize(2.02, 2.6),
      [countries.EU]: getSize(2.0, 2.5),
      [countries.DE]: getSize(2.0, 2.5),
    },
    quantity: {
      [countries.US]: getAssignedseatsBasedQuantities(0, 0.95, 0),
      [countries.UK]: getAssignedseatsBasedQuantities(0, 0.95, 0),
      [countries.FR]: getAssignedseatsBasedQuantities(1, 0.9, 0),
      [countries.EU]: getAssignedseatsBasedQuantities(0, 0, 0.95),
      [countries.DE]: getAssignedseatsBasedQuantities(0, 0, 0.95),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818105/insite/qa/spaces/zgblym2ugb7mgdc9kesl.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818105/insite/qa/spaces/zgblym2ugb7mgdc9kesl.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499747/insite/qa/spaces/x4qwutwknpryiwstw3nr.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818105/insite/qa/spaces/zgblym2ugb7mgdc9kesl.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818105/insite/qa/spaces/zgblym2ugb7mgdc9kesl.jpg',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
  {
    id: 7,
    name: 'spaceTypes.workstation.large',
    displayOrder: 4,
    spaceTypeId: spaceTypes.workstation.id,
    size: {
      [countries.US]: getSize(8.0, 8.0),
      [countries.UK]: getSize(8.0, 6.0),
      [countries.FR]: getSize(2.4, 2.4),
      [countries.EU]: getSize(2.5, 2.5),
      [countries.DE]: getSize(2.5, 2.5),
    },
    quantity: {
      [countries.US]: getAssignedseatsBasedQuantities(0.8, 0, 0),
      [countries.UK]: getAssignedseatsBasedQuantities(0.8, 0, 0),
      [countries.FR]: getAssignedseatsBasedQuantities(0.8, 0, 0),
      [countries.EU]: getAssignedseatsBasedQuantities(0, 0.8, 0),
      [countries.DE]: getAssignedseatsBasedQuantities(0, 0.8, 0),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818106/insite/qa/spaces/bvpnvgpksgsu2vtbuey6.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818106/insite/qa/spaces/bvpnvgpksgsu2vtbuey6.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818106/insite/qa/spaces/bvpnvgpksgsu2vtbuey6.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818106/insite/qa/spaces/bvpnvgpksgsu2vtbuey6.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818106/insite/qa/spaces/bvpnvgpksgsu2vtbuey6.jpg',
    },
    countries: [countries.US, countries.UK, countries.EU, countries.DE],
  },
];
